// extracted by mini-css-extract-plugin
export var divider = "_3k-0";
export var dividerText = "_3k-2";
export var dividerVertical = "_3k-1";